export function initStep0Data(phone, email, idType, idNumber) {
    return {
        phone: phone,
        email: email,
        idType: idType,
        idNumber: idNumber,
        isPhoneError: false,
        isEmailError: false,
        isIdNumberError: false
    }
}

export function initStep1Data(eKycFrontResponse, eKycBackResponse, eKycFaceResponse) {
    return {
        eKycFrontResponse: eKycFrontResponse,
        eKycBackResponse: eKycBackResponse,
        eKycFaceResponse: eKycFaceResponse,
    }
}

export function initStep2Data(productType, productCode, productName) {
    return {
        productType: productType,
        productCode: productCode,
        productName: productName
    }
}

export function initStep3Data(occupation, position, salary, company, refName, refPhone, relationship, note) {
    return {
        occupation: occupation,
        position: position,
        salary: salary,
        company: company,
        refName: refName,
        refPhone: refPhone,
        relationship: relationship,
        refNote: note,
        isSalaryError: false,
        isCompanyError: false,
        isRefPhoneError: false,
        isRefNameError: false,
    }
}

export function initStep4Data(baseAdress, permanentAddress, cardAddress) {
    return {
        baseAddress: baseAdress,
        permanentAddress: permanentAddress,
        cardAddress: cardAddress,
    }
}

export function initStep5Data() {
    return {
        isAgree: false
    }
}


